import React from 'react';
import { useSelector } from 'react-redux';
import useDuration from 'hooks/useDuration';
import { creationConfigurationIdSelector } from 'redux/modules/wizard-export/selectors';
import ExportVideoStepProgressOnly from '../ExportVideoStep/ExportVideoStepProgressOnly';

export interface VideoWizardFullEpisodeExportStepProps {
  mainVideoSrc: File | string;
  onError?: (error: Error) => void;
}

const VideoWizardFullEpisodeExportStep: React.FC<VideoWizardFullEpisodeExportStepProps> = ({
  mainVideoSrc,
  onError,
}) => {
  const configurationId = useSelector(creationConfigurationIdSelector);
  const durationSec = useDuration(mainVideoSrc);

  return (
    <ExportVideoStepProgressOnly
      widgetId={configurationId}
      estimatedDurationSec={Math.max(durationSec * 2, 60)}
      showEmailCallout={false}
      subtitle="You don't need to wait here, we'll email it to you soon."
      onError={onError}
    />
  );
};

export default VideoWizardFullEpisodeExportStep;
